<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
  >
    <path
      class="fill"
      d="M7.69333 1.65436V6.92282H14.5V0.5L7.69333 1.65436ZM7.69333 13.3657L14.5 14.5V8.08083H7.69333V13.3657ZM0.5 6.921H6.2536V1.84584L0.5 2.82148V6.921ZM0.5 12.2168L6.2536 13.176V8.08083H0.5V12.2168Z"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "MicrosoftIcon",
});
</script>

<style scoped lang="scss">
@use "../icon.scss";
</style>
